export async function fetchImageAsBytes(
  imageUri: string,
): Promise<Uint8Array | Blob> {
  const response = await fetch(imageUri);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const blob = await response.blob();

  // Check if the response is an image
  if (!blob.type.startsWith("image/")) {
    throw new Error("Invalid image format");
  }

  // Convert the Blob to a Buffer
  if (blob.arrayBuffer === undefined) {
    // arrayBuffer is undefined when using an image from local device.
    return blob;
  }

  const buffer = await blob.arrayBuffer();
  const bytes = new Uint8Array(buffer);

  return bytes;
}

export function formatSize(bytes: number): string {
  const sizes: string[] = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Bytes";
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
}
